



















import { Component, Ref, Vue } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { SnackbarModule } from "@/store/modules/SnackbarModule";

@Component({
  components: { "base-dialog": BaseDialogComponent },
})
export default class ClientPartnerPasswordDialog extends Vue {
  @Ref("baseDialog")
  baseDialog!: BaseDialogComponent;

  email: string | null = null;
  password = "";

  private resolve: (() => void) | null = null;

  /**
   * @param name - the external system, for the title.
   * @param email - the address it signs in with.
   * @param password - the password, shown this once.
   */
  show(name: string, email: string | null, password: string): Promise<void> {
    this.email = email;
    this.password = password;
    this.baseDialog.show({
      title: this.$t("admin.clients.partners.access.passwordTitle", [name]).toString(),
      positiveButtonText: this.$t("admin.clients.partners.access.done").toString(),
      negativeButtonText: null,
      maxWidth: 560,
      persistent: true,
    });
    return new Promise((resolve) => (this.resolve = resolve));
  }

  async onCopy() {
    try {
      await navigator.clipboard.writeText(this.password);
      SnackbarModule.showSuccess({ key: "admin.clients.partners.access.copied" });
    } catch {
      // A browser that refuses the clipboard: the password is still on screen to copy by hand.
      SnackbarModule.showError({ key: "admin.clients.partners.access.copyFailed" });
    }
  }

  /** BaseDialog has closed itself; the password leaves memory with it. */
  onDone() {
    this.password = "";
    this.resolve?.();
    this.resolve = null;
  }
}
